var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBearputSpread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 41H58",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeDasharray: "4 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41.5L16.5 19.5H7V15H18.5L44 41.5H37Z",
    fill: "#12B16E",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 45.5L36.5 41H43.5L48 45.5H61.4999V50H45.4999L41 45.5Z",
    fill: "#E94C69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0001 45.5L41.3536 45.1464L42.2072 46H41.0001V45.5ZM36.5001 41L36.1465 41.3536L35.293 40.5H36.5001V41ZM43.5001 41V40.5H43.7072L43.8536 40.6464L43.5001 41ZM48.0001 45.5V46H47.793L47.6465 45.8536L48.0001 45.5ZM61.5 45.5V45H62V45.5H61.5ZM61.5 50H62V50.5H61.5V50ZM45.5 50V50.5H45.2929L45.1465 50.3536L45.5 50ZM41.0001 45.5L40.6465 45.8536L39.7929 45H41L41.0001 45.5ZM40.6465 45.8536L36.1465 41.3536L36.8536 40.6464L41.3536 45.1464L40.6465 45.8536ZM36.5001 40.5H43.5001V41.5H36.5001V40.5ZM43.8536 40.6464L48.3536 45.1464L47.6465 45.8536L43.1465 41.3536L43.8536 40.6464ZM48.0001 45H61.5V46H48.0001V45ZM62 45.5V50H61V45.5H62ZM61.5 50.5H45.5V49.5H61.5V50.5ZM45.1465 50.3536L40.6465 45.8536L41.3536 45.1464L45.8536 49.6464L45.1465 50.3536Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5V53.5",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBearputSpread);
export default __webpack_public_path__ + "static/media/bear put Spread.a051e84532451b87c20a94d689eb592b.svg";
export { ForwardRef as ReactComponent };